import { render, staticRenderFns } from "./ListTabHeader.vue?vue&type=template&id=307a6e9e"
import script from "./ListTabHeader.ts?vue&type=script&lang=ts&external"
export * from "./ListTabHeader.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports